export default {
  createLoading: false,
  saveLoading: false,
  copyLoading: false,
  deleteLoading: {},
  loading: false,
  syncDataFetchLoading: { au: false, nz: false, uk: false },
  syncLoading: false,
  syncCompInstanceInfo: { au: [], nz: [], uk: [] },
  introLoading: false,
  page: 0,
  search: "",
  errors: null,
  success: null,
  operation: "update",
  compAllAttributes: null,
  compBasicAttributes: null,
  compAdditionalAttributes: null,
  compInstanceInfo: [],
  compInstanceDraft: [],
  compIntroInstanceInfo: [],
  description: {},

  // ********************* abi image slider *********************

  slideInstance: {},
  slideAttributes: {},
  slideLoading: false,
  sliderCreateLoading: false,
  sliderUpdateLoading: false,
  sliderCopyLoading: false,

  // ********************* global instance search ***************

  searchResult: [],
  searchLoading: false,

  // ********************* draft ********************************

  draftMode: "no", // draft mode status
  draftSaveLoading: false,
  draftCreateSaveLoading: false,

  // ********************* notice *******************************
  delayMessage: "",
  delayMessageUpdateLoading: false,
  delayMessageFetchLoading: false
};
